import frustumCull from './frustumCull'

export default `
  uniform vec3 uColor1;
  uniform vec3 uColor2;
  uniform vec4 uRectData;
  uniform vec3 uLightPos;

  varying vec2 vUv;
  varying vec3 vNormal;
  varying vec3 vNormal2;

  void main() {

    vec3 white = vec3(1.0);

    float l = dot(vNormal2, normalize(uLightPos)) * 0.5 + 0.5;

    l = pow(l, 4.0);


    vec3 color = mix(uColor1, uColor2, l);

    color = mix(color, white, vNormal.z);

    color = pow(color, vec3(1.0/2.2));

    ${frustumCull}
    gl_FragColor = vec4(color, 1.0);
  }
`
